import PropTypes from "prop-types"

const SizeChartItem = (props) => {
  const { value, label } = props
  return (
    <div className="row table-row">
      <div className="col-6">
        <span className="inch">{value}</span>
      </div>
      <div className="col-6">
        <span>{label}</span>
      </div>
    </div>
  )
}

SizeChartItem.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
}

export default SizeChartItem
